import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=b8e40c72&"
import script from "./Affiliates.vue?vue&type=script&lang=js&"
export * from "./Affiliates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VContainer,VDivider,VResponsive,VSlideGroup,VSlideItem})
